import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { ClassificationQuery, goToStyle, StyleLocationPayload } from "../../../ducks/location/location";
import { resetLayerTempStyle } from "../../../ducks/layerTempStyle/layerTempStyle";

export const useOpenStyle = (layer?: string, query?: ClassificationQuery): VoidFunction => {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(resetLayerTempStyle());
    dispatch(goToStyle({ layer } as StyleLocationPayload, query));
  }, [dispatch, layer, query]);
};
